var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('edit-data')],1),_c('div',{staticClass:"col-lg-6"},[_c('edit-password')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }